import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button } from '@mui/material';
import toast from 'react-hot-toast';

import { funcionCorreoType, obtenerCorreoCambiarContraseña } from './functions';
import Loading from '../../Utils/Loading';
import AfterVerication from './AfterVerification';

import logo from '../../Shared/Images/logo-tr4iner-negro.png';


const PasswordRecovery = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const [modalAfterVerification, setModalAfterVerification] = useState<boolean>(false);
  const [usuarioTestAsesoriaID, setUsuarioTestAsesoriaID] = useState<number>(0);

  const navigate = useNavigate();

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (_event, tipo: funcionCorreoType) => {
    setLoading(true);

    if (email === '') {
      toast.error('Por favor ingresa tu correo');
      setLoading(false);
      return;
    }

    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      setLoading(false);
      toast.error('El correo es inválido, por favor ingresa un correo válido');
      return;
    }

    // Lógica para enviar la solicitud de recuperación de contraseña

    obtenerCorreoCambiarContraseña(
      email,
      tipo,
      setLoading,
      setModalAfterVerification,
      setUsuarioTestAsesoriaID,
    );
  };

  return (
    <div className="h-[80dvh] w-[70%]  flex items-center justify-center flex-col gap-4 m-auto">
      {/* logo de tr4iner  */}

      <img
        onClick={() => navigate('/')}
        src={logo}
        alt="logo"
        className="cursor-pointer w-[170px] md:w-[250px]"
      />

      {/* texto de explicacion para recuperar contraseña */}

      <p className="text-center text-gray-600 lg:max-w-lg m-0">
        Por favor, ingrese su dirección de correo electrónico y número de teléfono
        asociados con su cuenta.
      </p>

      <section className="lg:w-[50%]">
        <TextField
          label="Correo electrónico"
          type="email"
          value={email}
          onChange={handleEmailChange}
          fullWidth
          margin="normal"
          required
        />
        <section className="flex flex-col gap-3 my-4">
          <Button
            variant="contained"
            className="bg-black"
            onClick={(event) => handleSubmit(event, 'recuperar')}
          >
            Recuperar contraseña
          </Button>
          {/* <Button
            variant="contained"
            className="bg-black"
            onClick={(event) => handleSubmit(event, 'cambiar')}
          >
            Cambiar Contraseña
          </Button> */}
        </section>
      </section>
      {loading && (
        <div className="h-[100dvh] w-[100dvw] z-[999999999] bg-white flex items-center justify-center absolute top-0 left-0">
          <Loading />
        </div>
      )}
      {modalAfterVerification && (
        <AfterVerication
          isOpen={modalAfterVerification}
          setIsOpen={setModalAfterVerification}
          usuarioTestAsesoriaID={usuarioTestAsesoriaID}
        />
      )}
    </div>
  );
};

export default PasswordRecovery;
